<script>
  import { fly } from 'svelte/transition'
  import store from '~/Library/store'
  import { createOfferSignup } from '~/Library/api'
  import { getCookie, setCookie } from '~/Library/cookies'

  export let card = {}

  let copied = false
  let prevIndex = -1

  $:if (prevIndex !== $store.card_index) {
    prevIndex = $store.card_index
    copied = false
  }

  function copy() {
    const el = document.createElement('textarea')
    el.value = 'planb'
    document.body.appendChild(el)
    el.select()
    document.execCommand('copy')
    document.body.removeChild(el)
    copied = true
  }

  function trackOfferSignup(){

    const cookieName = `__next4me_click_Mentors${card.id}`

    if ( !getCookie(cookieName)){

      createOfferSignup(`{
        user: { connect: { id: ${$store.user.id} } }
        offerMentor: {
          connect: {
            id: ${card.id}
          }
        },
        kind: "Mentor",
        title: "${card.title}"
      }`)
        .then((rsp) => true)
        .catch((err) => false)

      setCookie(cookieName, 1, (60 * 60 * 24 * 365))

    }
  }

</script>

<div class="offer" on:click|stopPropagation>

  <div class="offer__image">

    {#if card.image}

      <img src={card.image.publicUrlTransformed} alt="">

    {/if}

     {#if card.specialities1 || card.specialities2 || card.specialities3 || card.specialities4} 

      <small class="offer__specialities">Mentor Specialities</small>

    {/if}

    <ul class="offer__specialities-list">

      {#if card.specialities1}

        <li>

          <div>

            <img src="static/icons/attributes/tick2.png" />

          </div>

          <span>{card.specialities1}</span>

        </li>

      {/if}

      {#if card.specialities2}

        <li> 

          <div>

            <img src="static/icons/attributes/tick2.png" />

          </div>

          <span>{card.specialities2}</span>

        </li>

      {/if}

      {#if card.specialities3}

        <li>

          <div>

            <img src="static/icons/attributes/tick2.png" />

          </div>

          <span>{card.specialities3}</span>

        </li>

      {/if}

      {#if card.specialities4}

        <li>

          <div>

            <img src="static/icons/attributes/tick2.png" />

          </div>

          <span>{card.specialities4}</span>

        </li>

      {/if}

    </ul>

    {#if card.quote}

      <blockquote>

        <img class="left" src="/static/shapes/quote.svg" alt="">

        <h3 class="heading">{card.quote}</h3>

        <img class="right" src="/static/shapes/quote.svg" alt="">

      </blockquote>

    {/if}

  </div>
  
  <div class="offer__content">

    <img class="offer__background" src="/static/shapes/rectangle.svg" alt="">

    <h2 class="heading">{card.title}</h2>

    <div class="offer__focus">

      <span>{card.jobTitle}</span>

      {#if card.linkedinProfile}

        <a href={card.linkedinProfile} target="_blank">

          <img src="static/icons/li.svg" />

        </a>

      {/if}

    </div>

    <div class="offer__description">

      {@html card.long_description}

    </div>

    <a class="offer__cta-redeem" on:click={trackOfferSignup} href={card.bookingLink} target="_blank">Check Availability</a>

    <img class="offer__background bottom" src="/static/shapes/rectangle.svg" alt="">

  </div>

</div>

<style lang="scss">
  .offer {
    overflow: hidden;
    position: relative;
  }
  .offer__content {
    display: flex;
    flex-direction: column;
    .offer__description {
      flex-grow: 1;
    }
    a {
      width: fit-content; 
      align-self: flex-end;
      z-index: 10;
    }
  }
  .offer__focus {
    display: flex;
    align-items: center;
    margin: 1.5rem 0;
    span {
      color: var(--text-colour);
      font-weight: 300;
      font-size: 0.875rem;
    }
    img {
      margin-left: 0.5rem;
    }
  }
  .offer__image {
    > img {
      -webkit-filter: grayscale(100%); /* Safari 6.0 - 9.0 */
      filter: grayscale(100%);
      border-radius: 0.5rem;
      width: 18rem;
      height: 15rem;
      object-fit: cover;
    }
    .offer__specialities {
      display: inline-block;
      color: var(--light-text-colour);
      margin-top: 2.5rem;
      margin-bottom: 1rem;
    }

    ul {
      list-style: none;
      margin: 0;
      padding: 0;
      li {
        display: flex;
        align-items: center;
        margin: 0;
        margin-bottom: 0.5rem;
        div {
          display: flex;
          align-items: center;
          justify-content: center;
          height: 2.125rem;
          width: 2.125rem; 
          background-color: rgba(179, 208, 246, 0.12%);
          border-radius: 50%; 
          img {
            height: auto;
            width: 1.2rem;
          }
        }
        span {
          margin-left: 0.5rem;
          font-size: 0.875rem;
          color: var(--heading-colour);
        }
      }
    }
    blockquote {
      position: relative;
      padding: 1rem;
      margin: 2.5rem 0;
      h3 {
        text-align: center;
        line-height: 150%;
      }
      img {
        position: absolute;
        width: 5.5rem;
        height: auto;
        &.left {
          top: -10px;
          left: -10px;
        }
        &.right {
          bottom: -10px;
          right: -10px;
          -moz-transform: scale(-1, -1);
          -o-transform: scale(-1, -1);
          -webkit-transform: scale(-1, -1);
          transform: scale(-1, -1);
        }
      }
    }
  }
  .offer__background {
    position: absolute; 
    top: -350px;
    right: -100px;
    height: 30rem;
    width: 30rem;
    transform: rotate(55deg);
    &.bottom {
      top: initial;
      bottom: -650px;
      width: 52rem;
      height: 52rem;
      left: 190px;
      transform: rotate(62deg);
    }
  }

  @media only screen and (max-width: 576px) {
    .offer {
      &__background {
        display: none;
      }
      &__image {
        margin-bottom: 0px;
        padding-bottom: 0px;
      }
      &__image > img {
        width: 100%;
      }
      blockquote {
        margin: 2rem 0;
      }
      &__content {
        margin-top: 0;
        padding: 0.5rem 1.5rem;
      }
      &__cta-redeem {
        width: 100% !important; 
        box-sizing: border-box;
        text-align: center;
        margin-bottom: 1rem;
      }
    }
  }
</style>